import { CornerSquareTypes } from "../types";

export default {
  dot: "dot",
  square: "square",
  extraRounded: "extra-rounded",
  oneClassy: "one-classy",
  classy: "classy",
  oneClassyRotate: "one-classy-rotate",
  dotOneClassy: "dot-one-classy",
  middleRounded: "middle-rounded",
  gear: "gear"
} as CornerSquareTypes;
